import { useNavigate } from "react-router-dom";
import { fetchWrapper } from "../../utils/fetchWrapper";
import { PORTFOLIO_OWNER_AVATAR } from "../portfolio/ai-assistant/aiAssistantConfig";

function IconBell() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <path d="M18 16v-5a6 6 0 1 0-12 0v5l-2 2v1h16v-1l-2-2z" strokeLinejoin="round" />
         <path d="M10 20a2 2 0 0 0 4 0" strokeLinecap="round" />
      </svg>
   );
}

function IconLogout() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
         <path d="M16 17l5-5-5-5M21 12H9" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
   );
}

function IconChevron() {
   return (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
         <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
   );
}

function AdminTopbar({ unreadCount = 0 }) {
   const navigate = useNavigate();

   const logout = async () => {
      const response = await fetchWrapper(
         `${process.env.REACT_APP_BACKEND_API_URL}/auth/logout`,
         { method: "POST" }
      );
      if (response.status === 200) navigate("/admin");
   };

   return (
      <header className="admin-topbar">
         <div className="admin-topbar__actions">
            <button type="button" className="admin-topbar__icon-btn" aria-label="Notifications">
               <IconBell />
               {unreadCount > 0 ? (
                  <span className="admin-topbar__badge">
                     {unreadCount > 99 ? "99+" : unreadCount}
                  </span>
               ) : null}
            </button>

            <button type="button" className="admin-topbar__profile" aria-label="Admin profile menu">
               <img className="admin-topbar__avatar" src={PORTFOLIO_OWNER_AVATAR} alt="" />
               <span className="admin-topbar__profile-text">
                  <span className="admin-topbar__name">Admin User</span>
                  <IconChevron />
               </span>
            </button>

            <button type="button" className="admin-topbar__logout" onClick={logout}>
               <IconLogout />
               Log out
            </button>
         </div>
      </header>
   );
}

export default AdminTopbar;
